import { ArrowDown } from "@phosphor-icons/react";
import { MEDIA } from "@/data/content";
import { motion } from "framer-motion";
import BookCallDialog from "@/components/site/BookCallDialog";

export default function Hero() {
  return (
    <section
      id="top"
      data-testid="hero-section"
      className="relative min-h-screen w-full overflow-hidden grain-overlay"
    >
      {/* BG */}
      <div className="absolute inset-0">
        <img
          src={MEDIA.heroBackground}
          alt="Founder on location with camera rig at sunset"
          className="w-full h-full object-cover"
          style={{ objectPosition: "50% 35%" }}
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/55 via-black/45 to-[#050505]" />
      </div>

      {/* Top meta row */}
      <div className="relative z-10 pt-28 md:pt-32 px-6 md:px-12 lg:px-24 flex items-center justify-between">
        <div className="font-mono text-[10px] md:text-xs uppercase tracking-[0.3em] text-zinc-400 flex items-center gap-3">
          <span className="w-2 h-2 bg-[#E50914] inline-block" />
          <span>Est. 2017 — Studio / Production House</span>
        </div>
        <div className="hidden md:block font-mono text-[10px] uppercase tracking-[0.3em] text-zinc-500">
          N 40.71° — W 74.01°
        </div>
      </div>

      {/* Content */}
      <div className="relative z-10 px-6 md:px-12 lg:px-24 pt-20 md:pt-28 pb-32 md:pb-40">
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
          className="max-w-6xl"
        >
          <p
            data-testid="hero-eyebrow"
            className="font-mono text-xs md:text-sm uppercase tracking-[0.3em] text-[#E50914] mb-6"
          >
            // Vision Meets Execution
          </p>

          <h1
            data-testid="hero-title"
            className="font-display uppercase text-white leading-[0.88] tracking-tight text-[18vw] sm:text-[14vw] md:text-[10.5vw] lg:text-[9.5vw]"
          >
            <span className="block">Not content.</span>
            <span className="block">
              A <span className="text-[#E50914]">statement.</span>
            </span>
          </h1>

          <div className="mt-10 md:mt-14 max-w-2xl">
            <p
              data-testid="hero-sub"
              className="text-zinc-300 text-base md:text-lg leading-relaxed"
            >
              Millionare Mir Studio builds cinematic visuals for artists — music
              photography, high-energy music videos, and full-scale film rollouts.
              Storytelling, lighting, and motion, engineered to elevate your presence.
            </p>
          </div>

          <div className="mt-10 md:mt-14 flex flex-wrap items-center gap-4">
            <a
              href="#contact"
              data-testid="hero-cta-primary"
              className="inline-flex items-center gap-3 bg-[#E50914] hover:bg-[#B9090B] text-white px-7 py-4 font-mono text-xs uppercase tracking-[0.2em] transition-colors duration-200"
            >
              Start a Project
              <ArrowDown size={16} weight="bold" className="-rotate-45" />
            </a>
            <BookCallDialog />
          </div>
        </motion.div>
      </div>

      {/* Bottom strip */}
      <div className="absolute bottom-0 left-0 right-0 z-10 border-t border-white/10 bg-black/40 backdrop-blur-md">
        <div className="px-6 md:px-12 lg:px-24 py-5 flex flex-wrap items-center justify-between gap-3">
          <div className="font-mono text-[10px] md:text-xs uppercase tracking-[0.3em] text-zinc-400">
            Scroll to explore the work
          </div>
          <div className="flex items-center gap-6 font-mono text-[10px] md:text-xs uppercase tracking-[0.3em] text-zinc-500">
            <span>Photography</span>
            <span className="w-1 h-1 bg-zinc-700" />
            <span>Cinematic Video</span>
            <span className="w-1 h-1 bg-zinc-700" />
            <span>Film Production</span>
          </div>
        </div>
      </div>
    </section>
  );
}
